// fork of https://github.com/ngneat/dialog
import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BllDialogComponent } from './dialog.component';
import { BllDialogCloseDirective } from './dialog-close.directive';
import { GlobalDialogConfig } from './config';
import { GLOBAL_DIALOG_CONFIG } from './tokens';
import { BllDialogDraggableDirective } from './draggable.directive';
import {
  BaseDialogComponent,
  SuccessDialogComponent,
  ConfirmDialogComponent,
  ErrorDialogComponent,
} from './built-in-dialogs';

const BuiltIns = [BaseDialogComponent, SuccessDialogComponent, ConfirmDialogComponent, ErrorDialogComponent];

@NgModule({
  declarations: [BllDialogComponent, BllDialogCloseDirective, BllDialogDraggableDirective, BuiltIns],
  imports: [CommonModule],
  entryComponents: [BllDialogComponent],
  exports: [BllDialogComponent, BllDialogCloseDirective],
})
export class BllDialogModule {
  static forRoot(config: Partial<GlobalDialogConfig> = {}): ModuleWithProviders<BllDialogModule> {
    return {
      ngModule: BllDialogModule,
      providers: [
        {
          provide: GLOBAL_DIALOG_CONFIG,
          useValue: config,
        },
      ],
    };
  }
}
